import React, {useState} from "react";
import {useSelector} from "react-redux";

import Seat from "../../components/Seat";
import EmptySeat from "../../components/EmptySeat";

export default function Y6(props) {
    const { id, reservedSeats, preliminaryReservedSeats, announcedNumber, number } = props;

    const activeSeats = useSelector(state => state.activeSeats);

    const isAvailable = (carriageId, seatNumber) => {
        // Check if seat is permanently reserved
        const isReserved = reservedSeats.some(seat => {
            return (seat.carriageId === carriageId && String(seat.number) === String(seatNumber))
        });

        // Check if seat is preliminarily reserved by another user
        const isPreliminaryReserved = preliminaryReservedSeats && preliminaryReservedSeats.some(seat => {
            return (seat.carriageId === carriageId && String(seat.number) === String(seatNumber))
        });

        return !isReserved && !isPreliminaryReserved;
    };

    const isActive = (carriage, number) => {
        return Object.keys(activeSeats).some(seat => (seat.carriage === carriage && seat.seat === number))
    };

    return (
        <div className="wagon-box two-three dmu-rounded">
            <div className="wall-row">
                <span className="wall" />
                <span className="wall" />
                <span className="wall" />
                <span className="wall" />
            </div>
            <div className="seat-row">
                <EmptySeat />
                <EmptySeat />
                <EmptySeat />
                <Seat carriage={id} announcedNumber={announcedNumber} number="2" available={isAvailable(id, 2)} active={isActive(id, 2)} />
                <Seat carriage={id} announcedNumber={announcedNumber} number="1" available={isAvailable(id, 1)} active={isActive(id, 1)} />
            </div>
            <div className="wide" />
            <div className="seat-row">
                <EmptySeat />
                <EmptySeat />
                <EmptySeat />
                <Seat carriage={id} announcedNumber={announcedNumber} number="4" reverse={true} available={isAvailable(id, 4)} active={isActive(id, 4)} />
                <Seat carriage={id} announcedNumber={announcedNumber} number="3" reverse={true} available={isAvailable(id, 3)} active={isActive(id, 3)} />
            </div>
            <div className="wide" />
            <div className="seat-row">
                <Seat carriage={id} announcedNumber={announcedNumber} number="8" available={isAvailable(id, 8)} active={isActive(id, 8)} />
                <Seat carriage={id} announcedNumber={announcedNumber} number="7" available={isAvailable(id, 7)} active={isActive(id, 7)} />
                <Seat carriage={id} announcedNumber={announcedNumber} number="6" available={isAvailable(id, 6)} active={isActive(id, 6)} />
                <Seat carriage={id} announcedNumber={announcedNumber} number="5" available={isAvailable(id, 5)} active={isActive(id, 5)} />
            </div>
            <div className="wide" />
            <div className="seat-row">
                <Seat carriage={id} announcedNumber={announcedNumber} number="12" reverse={true} available={isAvailable(id, 12)} active={isActive(id, 12)} />
                <Seat carriage={id} announcedNumber={announcedNumber} number="11" reverse={true} available={isAvailable(id, 11)} active={isActive(id, 11)} />
                <Seat carriage={id} announcedNumber={announcedNumber} number="10" reverse={true} available={isAvailable(id, 10)} active={isActive(id, 10)} />
                <Seat carriage={id} announcedNumber={announcedNumber} number="9A" reverse={true} available={isAvailable(id, '9A')} active={isActive(id, '9A')} />
                <Seat carriage={id} announcedNumber={announcedNumber} number="9" reverse={true} available={isAvailable(id, 9)} active={isActive(id, 9)} />
            </div>
            <div className="seat-row">
                <Seat carriage={id} announcedNumber={announcedNumber} number="16" available={isAvailable(id, 16)} active={isActive(id, 16)} />
                <Seat carriage={id} announcedNumber={announcedNumber} number="15" available={isAvailable(id, 15)} active={isActive(id, 15)} />
                <Seat carriage={id} announcedNumber={announcedNumber} number="14" available={isAvailable(id, 14)} active={isActive(id, 14)} />
                <Seat carriage={id} announcedNumber={announcedNumber} number="13A" available={isAvailable(id, '13A')} active={isActive(id, '13A')} />
                <Seat carriage={id} announcedNumber={announcedNumber} number="13" available={isAvailable(id, 13)} active={isActive(id, 13)} />
            </div>
            <div className="wide" />
            <div className="seat-row">
                <Seat carriage={id} announcedNumber={announcedNumber} number="20" reverse={true} available={isAvailable(id, 20)} active={isActive(id, 20)} />
                <Seat carriage={id} announcedNumber={announcedNumber} number="19" reverse={true} available={isAvailable(id, 19)} active={isActive(id, 19)} />
                <EmptySeat />
                <Seat carriage={id} announcedNumber={announcedNumber} number="18" reverse={true} available={isAvailable(id, 18)} active={isActive(id, 18)} />
                <Seat carriage={id} announcedNumber={announcedNumber} number="17" reverse={true} available={isAvailable(id, 17)} active={isActive(id, 17)} />
            </div>
            <div className="wall-row">
                <span className="wall" />
                <span className="wall" />
                <span className="wall" />
                <span className="wall" />
            </div>
            <div className="seat-row">
                <Seat carriage={id} announcedNumber={announcedNumber} number="24" available={isAvailable(id, 24)} active={isActive(id, 24)} />
                <Seat carriage={id} announcedNumber={announcedNumber} number="23" available={isAvailable(id, 23)} active={isActive(id, 23)} />
                <EmptySeat />
                <Seat carriage={id} announcedNumber={announcedNumber} number="22" available={isAvailable(id, 22)} active={isActive(id, 22)} />
                <Seat carriage={id} announcedNumber={announcedNumber} number="21" available={isAvailable(id, 21)} active={isActive(id, 21)} />
            </div>
            <div className="wide" />
            <div className="seat-row">
                <Seat carriage={id} announcedNumber={announcedNumber} number="28" reverse={true} available={isAvailable(id, 28)} active={isActive(id, 28)} />
                <Seat carriage={id} announcedNumber={announcedNumber} number="27" reverse={true} available={isAvailable(id, 27)} active={isActive(id, 27)} />
                <Seat carriage={id} announcedNumber={announcedNumber} number="26" reverse={true} available={isAvailable(id, 26)} active={isActive(id, 26)} />
                <Seat carriage={id} announcedNumber={announcedNumber} number="25A" reverse={true} available={isAvailable(id, '25A')} active={isActive(id, '25A')} />
                <Seat carriage={id} announcedNumber={announcedNumber} number="25" reverse={true} available={isAvailable(id, 25)} active={isActive(id, 25)} />
            </div>
            <div className="seat-row">
                <Seat carriage={id} announcedNumber={announcedNumber} number="32" available={isAvailable(id, 32)} active={isActive(id, 32)} />
                <Seat carriage={id} announcedNumber={announcedNumber} number="31" available={isAvailable(id, 31)} active={isActive(id, 31)} />
                <Seat carriage={id} announcedNumber={announcedNumber} number="30" available={isAvailable(id, 30)} active={isActive(id, 30)} />
                <Seat carriage={id} announcedNumber={announcedNumber} number="29A" available={isAvailable(id, '29A')} active={isActive(id, '29A')} />
                <Seat carriage={id} announcedNumber={announcedNumber} number="29" available={isAvailable(id, 29)} active={isActive(id, 29)} />
            </div>
            <div className="wide" />
            <div className="seat-row">
                <Seat carriage={id} announcedNumber={announcedNumber} number="36" reverse={true} available={isAvailable(id, 36)} active={isActive(id, 36)} />
                <Seat carriage={id} announcedNumber={announcedNumber} number="35" reverse={true} available={isAvailable(id, 35)} active={isActive(id, 35)} />
                <Seat carriage={id} announcedNumber={announcedNumber} number="34" reverse={true} available={isAvailable(id, 34)} active={isActive(id, 34)} />
                <Seat carriage={id} announcedNumber={announcedNumber} number="33A" reverse={true} available={isAvailable(id, '33A')} active={isActive(id, '33A')} />
                <Seat carriage={id} announcedNumber={announcedNumber} number="33" reverse={true} available={isAvailable(id, 33)} active={isActive(id, 33)} />
            </div>
            <div className="seat-row">
                <Seat carriage={id} announcedNumber={announcedNumber} number="40" available={isAvailable(id, 40)} active={isActive(id, 40)} />
                <Seat carriage={id} announcedNumber={announcedNumber} number="39" available={isAvailable(id, 39)} active={isActive(id, 39)} />
                <Seat carriage={id} announcedNumber={announcedNumber} number="38" available={isAvailable(id, 38)} active={isActive(id, 38)} />
                <Seat carriage={id} announcedNumber={announcedNumber} number="37A" available={isAvailable(id, '37A')} active={isActive(id, '37A')} />
                <Seat carriage={id} announcedNumber={announcedNumber} number="37" available={isAvailable(id, 37)} active={isActive(id, 37)} />
            </div>
            <div className="wide" />
            <div className="seat-row">
                <Seat carriage={id} announcedNumber={announcedNumber} number="44" reverse={true} available={isAvailable(id, 44)} active={isActive(id, 44)} />
                <Seat carriage={id} announcedNumber={announcedNumber} number="43" reverse={true} available={isAvailable(id, 43)} active={isActive(id, 43)} />
                <EmptySeat />
                <Seat carriage={id} announcedNumber={announcedNumber} number="42" reverse={true} available={isAvailable(id, 42)} active={isActive(id, 42)} />
                <Seat carriage={id} announcedNumber={announcedNumber} number="41" reverse={true} available={isAvailable(id, 41)} active={isActive(id, 41)} />
            </div>
            <div className="wall-row">
                <span className="wall" />
                <span className="wall" />
                <span className="wall" />
                <span className="wall" />
            </div>
        </div>
    )
}
